import axios from 'axios'

const privateInstance = (token) => 
    axios.create({
        
        baseURL: ""+ process.env.REACT_APP_PRIVATE_API_URL +"",
        headers: {  "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Methods": "GET,POST",
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization":"OAuth "+ token
                },
        crossDomain: true,
        mode: 'CORS'
    });

export default privateInstance;
